import React,{useState, useEffect}  from "react";
import { fetchUser } from '../../utils/fetchUser';
import { getRegistroEntregasCliente } from "../../services/Reportes";

import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';

import HeaderStatsCliente from "../../components/Headers/HeaderStatsCliente.js";

const DashboardNClientes = () =>{
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('InicioAnno')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
  const userInfo = fetchUser();

  const [entregas, setEntregas] = useState(0); // Total Entregas

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const firstDayYear = new Date(today.getFullYear(), 0, 1);
    if(Como === 'InicioAnno') return firstDayYear;
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

    useEffect(()=>{
      const fetchData = async () => {
          
          const dataE = await getRegistroEntregasCliente(selectedDate.toISOString(),selectedDateEnd.toISOString(), userInfo.usuario);
          if (dataE){
            setEntregas(dataE.total);
          }
      };
      fetchData();
    },[selectedDate,selectedDateEnd]); 


  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  return (
    <>

    <div className="bg-white dark:bg-secondary-dark-bg p-4 max-w-4xl mx-auto rounded-2xl shadow-md mt-6">
      <div className="flex flex-col md:flex-row items-center justify-center gap-4 mt-8">
        <div className="grid grid-cols-2 md:grid-cols-2 gap-4" >
                <div>
                  <SeleccionaFecha
                    selectedDate={selectedDate}
                    handleDateChange={handleDateChange}
                  />
                </div>
                <div>
                  <SeleccionaFecha
                    selectedDate={selectedDateEnd}
                    handleDateChange={handleDateChangeEnd}
                  />
                </div>
          </div>      
        </div>

        <HeaderStatsCliente 
          entregasT={entregas}
          selectedDate={selectedDate.toISOString()}
          selectedDateEnd={selectedDateEnd.toISOString()}
        />

      </div>
    </>
  );
}

export default DashboardNClientes;